// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1advT","colBig":"styles_colBig__2gBf-","colSmall":"styles_colSmall__2pxBV"};